module.exports = __webpack_public_path__ + "bbe13316cb3963891e8f5c7d239055c7.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/SO.svg
// module id = UwWW
// module chunks = 0